import { render, staticRenderFns } from "./CEducation.vue?vue&type=template&id=d8d2d396"
import script from "./CEducation.vue?vue&type=script&lang=js"
export * from "./CEducation.vue?vue&type=script&lang=js"
import style0 from "./CEducation.vue?vue&type=style&index=0&id=d8d2d396&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8d2d396')) {
      api.createRecord('d8d2d396', component.options)
    } else {
      api.reload('d8d2d396', component.options)
    }
    module.hot.accept("./CEducation.vue?vue&type=template&id=d8d2d396", function () {
      api.rerender('d8d2d396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CEducation.vue"
export default component.exports